// removed by extract-text-webpack-plugin
module.exports = {"BreadBottom":"BurgerIngridient__BreadBottom__3o3sF","BreadTop":"BurgerIngridient__BreadTop__1_aRa","Seeds1":"BurgerIngridient__Seeds1__CpQ3C","Seeds2":"BurgerIngridient__Seeds2__3bS2P","Meat":"BurgerIngridient__Meat__2KTRk","Cheese":"BurgerIngridient__Cheese__wqdgE","Salad":"BurgerIngridient__Salad__2oH_E","Bacon":"BurgerIngridient__Bacon__1fRMz"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Burger/BurgerIngridient/BurgerIngridient.css
// module id = 57
// module chunks = 0